export default "__VITE_ASSET__BVD_4c4c__"